import { render, staticRenderFns } from "./NewRewardAdd.vue?vue&type=template&id=8b2eb68c&scoped=true"
import script from "./NewRewardAdd.vue?vue&type=script&lang=js"
export * from "./NewRewardAdd.vue?vue&type=script&lang=js"
import style0 from "./NewRewardAdd.vue?vue&type=style&index=0&id=8b2eb68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2eb68c",
  null
  
)

export default component.exports